import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';
import '../styles/payment.css';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="payment-page" data-testid="payment-cancel-page">
      <div className="payment-card">
        <div className="payment-icon cancel">
          <XCircle size={48} />
        </div>
        <h1>Pago cancelado</h1>
        <p>Tu pago ha sido cancelado. No se ha realizado ningún cargo.</p>
        <button
          className="payment-btn primary"
          onClick={() => navigate('/studio')}
          data-testid="go-back-btn"
        >
          <ArrowLeft size={16} />
          Volver al Studio
        </button>
      </div>
    </div>
  );
};

export default PaymentCancel;
